import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedReimaginedDocumentsIndexRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const dataSourceInfo = await this.reimaginedData.getDataSourceInfo();
    return { dataSourceInfo };
  }
}
